import type { SVGProps } from 'react'

import { cn } from '@/lib/utils'

/**
 * Users / people icon (Filled weight).
 *
 * Custom multi-user silhouette used on the admin Users page header.
 * Hardcoded dimensions stripped so the icon inherits sizing from
 * `className`/props (matching adjacent Lucide icons at the same size).
 */
export function UsersFilledIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={cn('size-4 shrink-0 text-current', className)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 7.25004C3.5 4.76474 5.51471 2.75 8 2.75C10.4853 2.75 12.5 4.76474 12.5 7.25004C12.5 9.73533 10.4853 11.7501 8 11.7501C5.51471 11.7501 3.5 9.73533 3.5 7.25004ZM8 4.25C6.34315 4.25 5 5.59316 5 7.25004C5 8.90692 6.34315 10.2501 8 10.2501C9.65685 10.2501 11 8.90692 11 7.25004C11 5.59316 9.65685 4.25 8 4.25Z"
        fill="currentColor"
      />
      <path
        d="M15.6032 15.1157C16.174 14.8836 16.8121 14.75 17.5003 14.75C20.2959 14.75 22.25 16.9434 22.25 19C22.25 19.4142 22.5858 19.75 23 19.75C23.4142 19.75 23.75 19.4142 23.75 19C23.75 16.0566 21.0648 13.25 17.5003 13.25C16.6156 13.25 15.7858 13.4222 15.0382 13.7262C14.6545 13.8822 14.4699 14.3197 14.6259 14.7034C14.7819 15.0872 15.2195 15.2717 15.6032 15.1157Z"
        fill="currentColor"
      />
      <path
        d="M1.75 20.5C1.75 17.9835 4.29449 15.25 8.00041 15.25C11.7062 15.25 14.25 17.9834 14.25 20.5C14.25 20.9142 14.5858 21.25 15 21.25C15.4142 21.25 15.75 20.9142 15.75 20.5C15.75 17.0166 12.3892 13.75 8.00041 13.75C3.61176 13.75 0.25 17.0165 0.25 20.5C0.25 20.9142 0.585786 21.25 1 21.25C1.41421 21.25 1.75 20.9142 1.75 20.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 4.75C15.567 4.75 14 6.31701 14 8.25C14 10.183 15.567 11.75 17.5 11.75C19.4329 11.75 20.9999 10.183 20.9999 8.25C20.9999 6.31701 19.4329 4.75 17.5 4.75ZM15.5 8.25C15.5 7.14542 16.3954 6.25 17.5 6.25C18.6045 6.25 19.4999 7.14542 19.4999 8.25C19.4999 9.35458 18.6045 10.25 17.5 10.25C16.3954 10.25 15.5 9.35458 15.5 8.25Z"
        fill="currentColor"
      />
    </svg>
  )
}
